import {LangChangeEvent, MissingTranslationHandler, TranslateCompiler, TranslateLoader, TranslateParser, TranslateService, TranslateStore} from '@ngx-translate/core';
import {EventEmitter, Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs/internal/firstValueFrom';
import {defer, filter, Observable, switchMap, timer} from 'rxjs';
import { MmProjectService } from './mm-project/mm-project.service';
import { AuthService, ClaimTypes, JwtAuthService } from '@mydocma/auth';
import { Project } from '@docma-mm-core/project/project';
import { KeywordService } from '@docma-core/keyword/keyword.service';
import {constants} from '@docma-mm-core/constants';

export interface TranslationItem {
  id: any;
  lang: string;
  value: string;
  key: string;
}

@Injectable({providedIn: 'root'})
export class MmTranslateService extends TranslateService {

  private jwtAuthService: JwtAuthService;

  private keyWordsStore = new Map<string, Object>();
  private currentLangKeyWords: Object;

  public currentProject = null;

  private onLangChangeHandled = new EventEmitter<LangChangeEvent>();

  private prefixKey: string;


  /**
   *
   */
  constructor(store: TranslateStore, currentLoader: TranslateLoader, compiler: TranslateCompiler,
              parser: TranslateParser, missingTranslationHandler: MissingTranslationHandler,
              private authService: AuthService,
              private keywordservice: KeywordService,
              private projectService: MmProjectService) {

    super(store, currentLoader, compiler, parser, missingTranslationHandler,true,false,false,null);

    projectService.currentProject.pipe(filter(Boolean))
    .subscribe(async p=> await this.onProjectCahnged(p));
    this.jwtAuthService = this.authService as any as JwtAuthService;

    super.onLangChange.pipe(switchMap(lce=> this.handleLangChange(lce)))
    .subscribe(lce=> this.onLangChangeHandled.next(lce))



  }


  private async handleLangChange(lce: LangChangeEvent) {
    this.currentLangKeyWords = this.keyWordsStore.get(`${this.prefixKey}.${lce.lang}`);
    return lce;
  }


  get onLangChange(): EventEmitter<LangChangeEvent> {
    return this.onLangChangeHandled;
  }

  ///  ###Faults#Mängel###
  private getParsedKeyWordsResult(translation: string): {parsedValue: string, hasKeyWord: boolean} {
    const result = {hasKeyWord: false, parsedValue: translation};
    if (!translation?.replace) {
      return result;
    }
    const parsedValue = translation.replace(new RegExp(/\###(.*?)\###/g), (found: string)=>{
      result.hasKeyWord = true;
      let keyWordEx= found.replace(/###/g,'');
      let defaultValue: string;
      let keyWord = keyWordEx;
      const defaultIndex = keyWordEx.indexOf('#');
      if (defaultIndex>0) {
        keyWord = keyWordEx.substring(0,defaultIndex);
        defaultValue = keyWordEx.substring(defaultIndex+1);
      }
      const keyWordTranslation = this.currentLangKeyWords && this.currentLangKeyWords[keyWord];
      return keyWordTranslation || defaultValue || found;

     });
     result.parsedValue = parsedValue;
     return result;
  }

  override getParsedResult(translations: any, key: string, interpolateParams?: {}): string {

    const parsedValue = super.getParsedResult(translations, key, interpolateParams);
    const parsedKeyWordsResult = this.getParsedKeyWordsResult(parsedValue);
    return parsedKeyWordsResult.parsedValue;
  }


  private async onProjectCahnged(p: Project) {
    console.log('TranslateService.project', p);
    const claims = await this.jwtAuthService.getAccessTokenClaims();
    const db_id = claims[ClaimTypes.db_id];
    const db_schema = claims[ClaimTypes.db_schema]
    if (db_schema && db_id) {
      this.prefixKey = `${db_id}.${db_schema}`;
      await this.loadKeyWords();
    }
  }

  private async loadKeyWords() {

    const key = `${this.prefixKey}.${this.currentLang}`
    const cached = this.keyWordsStore.get(key);
    if (cached) {
      this.currentLangKeyWords = cached;
    } else {
      this.currentLangKeyWords = null;
      this.keyWordsStore= new Map();
      // add empty stories for each lang
      this.langs.forEach(l => this.keyWordsStore.set(`${this.prefixKey}.${l}`,{}));

      const keyWords = await firstValueFrom(this.keywordservice.getKeywords(constants.MaxInt, 0));

      if (keyWords.Count > 0) {
        keyWords.Data.forEach(kv => {
          const lang = kv.Lang.substring(0,2);
          let langStore = this.keyWordsStore.get(`${this.prefixKey}.${lang}`);
          if (!langStore) {
            langStore = {};
            this.keyWordsStore.set(`${this.prefixKey}.${lang}`, langStore);
          }
          langStore[kv.Key] = kv.Value;
        });
      }
      this.currentLangKeyWords = this.keyWordsStore.get(key);
      this.onLangChangeHandled.emit({lang: this.currentLang, translations: this.translations[this.currentLang]});
    }

  }



}

